export const queryParams = {
    investorIdParamName: "investorId"
};
export const comparisonAliases = {
    comparate: (index) => `Comparate${index}`,
    diff: (main, comparate) => `${main}-${comparate}`,
    main: "Main"
};
export const preview = {
    sectionId: "previewSection",
    widgetId: "previewWidget"
};
export const inspectData = {
    sectionId: "previewSection",
    widgetId: "inspectDataWidget"
};
export const InsBenchmarkCreationBlendedGridId = "benchmark-creation-blended-grid";
export const insPortfoliosStateId = "all-portfolios-grid";
export const insPacingPlansStateId = "all-pacing-plans-grid";
export const insFundsStateId = "all-funds-grid";
export const insManagersStateId = "all-managers-grid";
export const insAssetsStateId = "all-assets-grid";
export const insInvestorsStateId = "all-InvestorAccount-grid";
